/*eslint-disable */
import { LoadData } from "@store/accounting/invoicing/types";
import { DateTime } from "luxon";

const getClassforMode = (mode: string) => {
  if (mode == "LTL") {
    return "bg-[#B00020] text-white p-1 rounded-md w-fit";
  }
  return "";
};

const bgClasses = (state: string) => {
  switch (state) {
    case "Synched":
      return "bg-[#EFE497]! text-[#333]";
    case "Processed":
      return "bg-[#A8EAA8]! text-[#333]";
    case "FailedProcessing":
      return "bg-[#F8ADAD]! text-[#333]";
    default:
      return "";
  }
};

const highestLevelTransfloLog = (load: LoadData) => {
  if (!load?.documentUploadHistory?.length) return null;

  return load.documentUploadHistory.reduce((latest, current) => {
    return new Date(current.dateReceived) > new Date(latest.dateReceived)
      ? current
      : latest;
  });
};

const highestLevelTransfloStatus = (load: LoadData | null) => {
  if (load == null || load.documentUploadHistory == null) return "";
  const log = highestLevelTransfloLog(load);
  return log == null ? "" : log.transfloStatus;
};

const getCarrierStatusClass = (load: LoadData) => {
  const transflowStatus = highestLevelTransfloStatus(load);
  if (
    transflowStatus == "Needs Agent Approval" ||
    transflowStatus == "Exceptions Found"
  ) {
    return "bg-[#EFB02A]";
  } else if (transflowStatus == "Manually-Approved") {
    return "bg-[#123B50]";
  } else if (transflowStatus == "Auto-Approved") {
    return "bg-[#248670]";
  }
  return "";
};

const getStatusClassForLoad = (status: string) => {
  switch (status) {
    case "Assigned":
      return "bg-[#FFFFC1]";
    case "Unassigned":
      return "bg-[#FFC1C1]";
    case "Dispatched":
      return "bg-[#AAD9ED]";
    case "Loaded":
      return "bg-[#9ACC9A]";
    case "At Shipper":
      return "bg-[#AEA3FF]";
    case "At Receiver":
      return "bg-[#FFFFFF]";
    case "Out On Delivery":
      return "bg-[#F7BF51]";
    case "In Transit":
      return "bg-[#67E667]";
    case "On Hold":
      return "bg-[#F97C6B]";
    case "Tendered":
      return "bg-[#c1fcff]";
    case "Empty":
      return "bg-[#FFF]";
    case "Can Get":
      return "bg-[#E4E6EF]";
    default:
      return "";
  }
};
const loadHasTransfloStatus = (load: LoadData | null) => {
  return (
    load != null &&
    load.documentUploadHistory != null &&
    load.documentUploadHistory.some((d) => d.transfloStatus != null)
  );
};

const checkFormatAndSetDate = (inputDate: string) => {
  const parsed = DateTime.fromFormat(inputDate, "M/d/yyyy");
  if (parsed.isValid) {
    const output = parsed
      .set({ hour: 0, minute: 0, second: 0 })
      .toISO({ includeOffset: false });
    return output;
  } else {
    return inputDate; // Return the original input if parsing fails
  }
};

export {
  getClassforMode,
  getCarrierStatusClass,
  getStatusClassForLoad,
  bgClasses,
  highestLevelTransfloStatus,
  highestLevelTransfloLog,
  loadHasTransfloStatus,
  checkFormatAndSetDate,
};
